import { Col, Row, Table, Tabs } from 'antd';
import { IconRecipe } from '../../../assets/index';
import moment from 'moment';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import BreadCrumbComponent from '../../../components/breadcrumb/BreadCrumbComponent';
import PaginationTable from '../../../components/pagination/Pagination';
import useDashboardDetail from '../../../hooks/useDashboardDetail';
import { routes } from '../../../utils/constants/constant';
import { formatMoney, isEmpty } from '../../../utils/helpers/helpers';
import { getCommissionHistoryDetail } from '../actions';
import './DashboarDetail.scss';

const breadCrumbs = [
  {
    name: 'Trang chủ',
    isLink: false,
  },
  {
    name: 'Tổng quan',
    isLink: true,
    link: routes.DASHBOARD,
  },
  {
    name: 'Chi tiết thu nhập',
    isLink: false,
  },
];
const { TabPane } = Tabs;
const DashBoarDetail = (props) => {
  const {
    onChangePagination,
    handleSortDate,
    sortBy,
    listIncomeStaticDetails,
    totalElements,
    incomeStatic,
    params,
    columns,
  } = useDashboardDetail({ ...props });
  function callback(key) {}
  const [listData, setListData] = useState([]);
  const fetCommissionHistoryDetail = async () => {
    try {
      const { data } = await getCommissionHistoryDetail();
      if (data.code === 200) {
        setListData(data?.data?.items);
      }
    } catch (err) {}
  };
  useEffect(() => {
    fetCommissionHistoryDetail();
  }, []);
  return (
    <div className='container-dashboard-detail'>
      <BreadCrumbComponent breadCrumbs={breadCrumbs} />
      <div className='title-container-dashboard-detail '>Thu nhập</div>
      <Tabs defaultActiveKey='1' onChange={callback} size='large'>
        <TabPane tab='Chi tiết thu nhập' key='1'>
          <div className='header'>
            <div
              className={`header-sort ${
                sortBy === 7 ? 'header-sort-7day' : ''
              } `}
              onClick={() => {
                handleSortDate(7);
              }}
            >
              7 ngày trước
            </div>
            <div
              className={`header-sort ${
                sortBy === 30 ? 'header-sort-30day' : ''
              } `}
              onClick={() => {
                handleSortDate(30);
              }}
            >
              30 ngày trước
            </div>
            <div
              className={`header-sort ${
                sortBy === 90 ? 'header-sort-90day' : ''
              } `}
              onClick={() => {
                handleSortDate(90);
              }}
            >
              90 ngày trước
            </div>
          </div>
          <div className='content-body'>
            <Row>
              <Col span={8}>
                <div className='content'>
                  <div className='title'>Tổng doanh số</div>
                  <div className='count'>
                    {`${formatMoney(incomeStatic.revenue || 0)}`}
                  </div>
                  <div className='currency'>VNĐ</div>
                </div>
              </Col>
              <Col span={8} style={{ padding: '0 24px' }}>
                <div className='content'>
                  <div className='title'>Đơn hàng đã đặt</div>
                  <div className='count'>{`${formatMoney(
                    incomeStatic.gmv || 0
                  )}`}</div>
                  <div className='currency'>VNĐ</div>
                </div>
              </Col>
              <Col span={8}>
                <div className='content'>
                  <div className='title'>Đơn hàng đã hoàn tiền</div>
                  <div className='count'>{`${formatMoney(
                    incomeStatic.refundAmount || 0
                  )}`}</div>
                  <div className='currency'>VNĐ</div>
                </div>
              </Col>
            </Row>
          </div>

          <div className='data-month'>
            {sortBy === 7
              ? 'Dữ liệu theo tuần'
              : sortBy === 30
              ? 'Dữ liệu theo tháng'
              : 'Dữ liệu theo quý'}
          </div>
          <div className='content-table'>
            <Table
              columns={columns}
              dataSource={listIncomeStaticDetails}
              pagination={false}
            />
            {!isEmpty(listIncomeStaticDetails) && totalElements > 0 && (
              <PaginationTable
                page={params.pageNum}
                size={params.pageSize}
                onChange={onChangePagination}
                totalElements={totalElements}
              />
            )}
          </div>
        </TabPane>
        <TabPane tab='Lịch sử thu nhập theo tháng' key='2'>
          <>
            {listData?.length > 0 ? (
              <div className='right-dashboard-desk'>
                <div className='mobile-header-right-tab'>
                  <div className='cell-header left'>Tháng</div>
                  <div className='cell-header right'>Thu nhập</div>
                </div>
                {listData?.map((v, index) => (
                  <div className='mobile-body-right-tab' key={index}>
                    <div className='cell-body left'>
                      {moment(v?.completedDate, 'DD/MM/YYYY').format('MM/YYYY')}
                    </div>
                    <div className='cell-body right'>
                      {`${formatMoney(v.commission || 0)}`}đ
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className='empty-table'>
                <IconRecipe />
                <span style={{ paddingTop: 10 }}>Chưa có dữ liệu</span>
              </div>
            )}
          </>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default DashBoarDetail;
